import React from 'react';
// @ts-ignore
import { Row, Cell } from '@els/els-react--table';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
import { formatDate } from '../../../../libs/utils/helper/date-helper';

const EbpcSkillListRow = ({
    courseId,
    skillName,
    dateUpdated,
    className,
    handleRedirectToSkillDetail,
}: any) => {
    const baseClassName = `${className}__row`;
    return (
        <Row className={`${baseClassName}`}>
            <Cell className={`${baseClassName}__cell-skillName`}>
                <LinkElement
                    className={`${baseClassName}__cell-button`}
                    inline
                    href=""
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        handleRedirectToSkillDetail(courseId);
                    }}
                >
                    {skillName}
                </LinkElement>
            </Cell>

            <Cell className={`${baseClassName}__cell-dateUpdated`}>
                {formatDate(dateUpdated, 'MMMM yyyy')}
            </Cell>
        </Row>
    );
};
export default EbpcSkillListRow;
